import { Box, ChakraProvider } from '@chakra-ui/react'
import { ToastContainer, Zoom } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import clientTheme from './assets/themes/clientTheme'

// App is now just a wrapper for ChakraUI theme
export const App = ({ children }: { children: React.ReactNode }) => (
  <ChakraProvider theme={clientTheme}>
    <Box h='100vh'>
      {children}
      <ToastContainer
        position='top-right'
        autoClose={10000}
        hideProgressBar={true}
        transition={Zoom}
        pauseOnHover
      />
    </Box>
  </ChakraProvider>
)

export default App
